export const HOME_ROUTE = "/";
export const AUTH_ROUTE = "/auth";
export const REGISTER_ROUTE = "/register";
export const CHANGE_ROUTE = "/change";
export const CONTACTS_ROUTE = "/contacts";
export const ROAD_ROUTE = "/road";
export const CABINET_ROUTE = "/profile";
export const REQUEST_ROUTE = "/create-request";
export const CRYPTOTABLE_ROUTE = "/crypto-table";
export const TERMS_ROUTE = "/terms";
export const FORGOT_PASSWORD_ROUTE = "/fgpass";
export const SITEMAP_ROUTE = "/site_map";
export const NOTICE_ROUTE = "/notice";
export const EXINSTRUCTION = "/exchange_instruction";
